import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import getUser from 'Utils/userAuth';
import { token as localStorageToken } from 'Utils/envLoader';

const AuthVerify = ({ history, logOut }) => {
    let historyLisetener;
    useEffect(() => {
        historyLisetener = history.listen(() => {
            const token = localStorage.getItem(localStorageToken);
            if (token) {
                const decodedJwt = getUser(token);
                if (decodedJwt.exp * 1000 < Date.now()) {
                    logOut();
                } else if (
                    decodedJwt.MustChangePassword === 'True' &&
                    window.location.pathname !== '/profile/password' &&
                    window.location.pathname !== '/login' &&
                    window.location.pathname !== '/password/forget' &&
                    !window.location.pathname.includes('/password/reset/') &&
                    !window.location.pathname.includes('/activation/') &&
                    window.location.pathname !== '/not-found'
                ) {
                    history.replace('/profile/password');
                }
            } else logOut();
        });
        return () => {
            historyLisetener();
        };
    }, []);

    return <></>;
};

export default withRouter(AuthVerify);
